import React, { useRef, useState } from "react";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { Button } from "primereact/button";
import Toolbar from "../../componentes/toolbar/Toolbar";
import useFullPageLoader from "react-comun-seps/lib/components/FullPageLoaderHooks/useFullPageLoader";
import { Toast } from "primereact/toast";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import RevisarEntidadConstitución from "./RevisarEntidadConstitución";
import RevisarSociosConstitucion from "./RevisarSociosConstitucion";
import RevisarDirectivaConstitucion from "./RevisarDirectivaConstitucion";
import RevisarOficialCumplimientoConstitucion from "./RevisarOficialCumplimientoConstitucion";

const RevisarConstitucion = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { datos, codSolReservaDenominacion, codSolConstitucion } = location.state || {};
  const stepperRef = useRef(null);
  const toast = useRef(null);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [constitucion, setConstitucion] = useState({});

  return (
    <>
      {loader}
      <Toast ref={toast} />
      <div className="card">
        <Toolbar>
          <React.Fragment>
            <Button
              label="Cancelar"
              icon="pi pi-times-circle"
              type="button"
              severity="info"
              onClick={(e) => {
                navigate("/solicitudes-constitucion", { state: { ...location.state } });
              }}
            />
          </React.Fragment>
        </Toolbar>
        <div className="text-center">
          <div className="font-semibold text-lg text-blue-700">
            Solicitud de {constitucion?.nomCatTipoSolicitud ?? ""}:{" "}
            {constitucion?.numSolicitud ?? ""}
          </div>
          <div className="font-semibold text-base m-2">
            Estado: {constitucion?.nomCatEstadoSolicitud}
          </div>
        </div>
        <Stepper className="stepperConstitucion" ref={stepperRef} style={{ flexBasis: "50rem" }}>
          <StepperPanel header="Entidad">
            <RevisarEntidadConstitución
              showLoader={showLoader}
              hideLoader={hideLoader}
              dispatch={dispatch}
              toast={toast}
              datos={datos}
              codSolReservaDenominacion={codSolReservaDenominacion}
              codSolConstitucion={codSolConstitucion}
              setConstitucion={setConstitucion}
            />
          </StepperPanel>
          <StepperPanel header="Socios">
            <RevisarSociosConstitucion
              showLoader={showLoader}
              hideLoader={hideLoader}
              dispatch={dispatch}
              toast={toast}
              codSolConstitucion={codSolConstitucion}
            />
          </StepperPanel>
          <StepperPanel header="Directiva">
            <RevisarDirectivaConstitucion
              showLoader={showLoader}
              hideLoader={hideLoader}
              dispatch={dispatch}
              toast={toast}
              codSolConstitucion={codSolConstitucion}
              codGrupoConstAdec={constitucion?.codGrupoConstAdec ?? null}
            />
          </StepperPanel>
          <StepperPanel header="Oficial de cumplimiento">
            <RevisarOficialCumplimientoConstitucion
              showLoader={showLoader}
              hideLoader={hideLoader}
              dispatch={dispatch}
              toast={toast}
              codSolConstitucion={codSolConstitucion}
            />
          </StepperPanel>
        </Stepper>
      </div>
    </>
  );
};
export default RevisarConstitucion;
